import { Helmet } from "react-helmet";
import Dashboard from "../../../layouts/Dashboard";
import AccountInfoCard from "../AccountInfoCard/AccountInfoCard";
import CoreSubscriptions from "../CoreSubscriptions/CoreSubscriptions";
import AddOnSubscriptions from "../AddOnSubscriptions/AddOnSubscriptions";
import { AppContext } from "../../../context/app";
import { useContext } from "react";
import { useGetClientSubscriptionSummary } from "../../../apis/billingApi.hooks";
import { Loader } from "@pushpress/shared-components";

export const ACCOUNT_PAGE_TITLE = "Your PushPress Plan";

function AccountLanding() {
  const app = useContext(AppContext);

  const { data: subscriptionSummaries = [], isLoading } =
    useGetClientSubscriptionSummary(app.client.uuid);

  return (
    <>
      <Helmet>
        <title>{ACCOUNT_PAGE_TITLE}</title>
      </Helmet>
      {isLoading ? (
        <div className="tw-flex tw-justify-center tw-items-center tw-h-full">
          <Loader />
        </div>
      ) : (
        <Dashboard scrollableContent disableContentPadding>
          <div className="tw-py-12 tw-px-16 tw-mx-auto">
            <div>
              <h2 className="tw-text-lg tw-font-bold tw-text-neutral-700 tw-mb-6">
                Your PushPress Plan
              </h2>
              <AccountInfoCard subscriptionSummaries={subscriptionSummaries} />
            </div>

            <div className="tw-mt-12">
              <h2 className="tw-text-lg tw-font-bold tw-text-neutral-700 tw-mb-6">
                Upgrade Core
              </h2>
              <CoreSubscriptions
                subscriptionSummaries={subscriptionSummaries}
              />
            </div>

            <div className="tw-mt-12">
              <AddOnSubscriptions
                subscriptionSummaries={subscriptionSummaries}
              />
            </div>
          </div>
        </Dashboard>
      )}
    </>
  );
}

export default AccountLanding;
